<header class="top-bar">
    <div class="top-bar-left">
      <span class="page-title">Sistema de Gestão</span>
    </div>
  
    <div class="top-bar-right">
      <div class="user-profile">
        <div class="user-details">
          <span class="user-name">{{ userName }}</span>
          <span class="user-role">{{ userCompany }}</span>
        </div>
        <div class="user-avatar">
          <i class="bi bi-person-circle"></i>
        </div>
      </div>
      
      <div class="divider"></div>
  
      <button class="action-btn logout-btn" (click)="onLogout()">
        <i class="bi bi-box-arrow-right"></i>
      </button>
    </div>
  </header>